import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { FormControlComponent, PrimengButtonDirective } from '@web/shared/ui';
import { Nillable } from '@web/utils';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-public-order-checkout-discount-code',
  imports: [
    InputText,
    FormControlComponent,
    ReactiveFormsModule,
    Button,
    PrimengButtonDirective,
  ],
  templateUrl: './public-order-checkout-discount-code.component.html',
  styleUrl: './public-order-checkout-discount-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicOrderCheckoutDiscountCodeComponent {
  private readonly builder = inject(FormBuilder);

  public readonly submitEvent = output<Nillable<string>>();

  protected readonly discountFormControl: FormControl<Nillable<string>>;

  public constructor() {
    this.discountFormControl = this.prepareDiscountFormControl();
  }

  protected handleSubmitClick(): void {
    this.submitEvent.emit(this.discountFormControl.value);
  }

  private prepareDiscountFormControl(): FormControl<Nillable<string>> {
    return this.builder.control<Nillable<string>>(null);
  }
}
